import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Main from "./Main";
import Navbar from "./Navbar";
function App() {
  return (
    <Router>
      <div className="App">
        <div>
          <Navbar />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Main />
                </>
              }
            ></Route>
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
